import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TracingModel } from 'projects/phdsoft/common/src/lib/models/tracing.model';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";
import { TracingFilters } from '../pages/tracing/tracing-filters.model';

@Injectable({
  providedIn: 'root'
})
export class TracingService {

constructor(
  private http: HttpClient,
) { }

  getAll(filters:TracingFilters): Observable<TracingModel[]> {
      return this.http.post<TracingModel[]>(
        environment.API_TRACING + 'Audit/GetAll', filters)
  }

  countItems(filters:TracingFilters): Observable<number> {
    return this.http.post<number>(
      environment.API_TRACING + 'Audit/CountItems', filters)
  }
}
